module.exports = __webpack_public_path__ + "files/e44afb33c859f8ad9ec8b3e419244f7b.png";